import * as React from 'react';
import { DataGrid } from '@material-ui/data-grid';

function FinancialFilingDataGrid({data} :any) {

  const columns = [
    { field: 'id', hide: true },
    { field: 'filingDate', width: 100, headerName: 'Date', sortable: true, renderHeader:(params) => ( <strong>Date</strong>)},
    { field: 'filing', width: 180, headerName: 'Filing', sortable: false, renderHeader:(params) => ( <strong>Filing</strong>),renderCell: (params) => (<a target="_blank" rel="noopener noreferrer" href={ params.getValue(params.id, 'url') }>{params.value}</a>)},
    { field: 'formType', hide: true},
    { field: 'url', hide: true}
  ]

  function buildCompanyData(item) {
    return {
      id: item.id,
      filingDate: item.last_modified_date,
      filing: item.filing_name,
      formType: item.form_type,
      url: item.url
    }
  }

  const rows = data?.map(item => buildCompanyData(item));

  return (
    <div className="row">
      <style>{`
        .financial-filing-grid {
          width: 100%;
        }

        .financial-filing-grid .MuiDataGrid-root {
          border: 1px solid #e5e7eb;
          background: #ffffff;
        }

        .financial-filing-grid .MuiDataGrid-columnHeaders {
          background: #f9fafb;
          border-bottom: 1px solid #e5e7eb;
        }

        .financial-filing-grid .MuiDataGrid-columnHeader,
        .financial-filing-grid .MuiDataGrid-cell {
          border-bottom: 1px solid #f3f4f6;
        }

        .financial-filing-grid .MuiDataGrid-cell {
          color: #111827;
        }

        .financial-filing-grid .MuiDataGrid-cell:focus,
        .financial-filing-grid .MuiDataGrid-columnHeader:focus,
        .financial-filing-grid .MuiDataGrid-cell:focus-within,
        .financial-filing-grid .MuiDataGrid-columnHeader:focus-within {
          outline: none;
        }

        .financial-filing-grid .MuiDataGrid-row:hover {
          background: #f9fafb;
        }

        .financial-filing-grid .MuiDataGrid-footerContainer {
          border-top: 1px solid #e5e7eb;
          background: #ffffff;
        }

        .financial-filing-grid .MuiTablePagination-root,
        .financial-filing-grid .MuiTablePagination-caption,
        .financial-filing-grid .MuiTablePagination-selectIcon,
        .financial-filing-grid .MuiIconButton-root {
          color: #4b5563;
        }

        .dark-mode .financial-filing-grid .MuiDataGrid-root {
          border-color: #322f2f;
          background: #222328;
          color: #ffffff;
        }

        .dark-mode .financial-filing-grid .MuiDataGrid-columnHeaders {
          background: linear-gradient(to right, #1a191d, #222328);
          border-bottom-color: #322f2f;
        }

        .dark-mode .financial-filing-grid .MuiDataGrid-columnHeader,
        .dark-mode .financial-filing-grid .MuiDataGrid-cell {
          border-bottom-color: #322f2f;
        }

        .dark-mode .financial-filing-grid .MuiDataGrid-cell {
          color: #ffffff;
        }

        .dark-mode .financial-filing-grid .MuiDataGrid-row:hover {
          background: rgba(255, 255, 255, 0.03);
        }

        .dark-mode .financial-filing-grid .MuiDataGrid-footerContainer {
          border-top-color: #322f2f;
          background: #1a191d;
        }

        .dark-mode .financial-filing-grid .MuiTablePagination-root,
        .dark-mode .financial-filing-grid .MuiTablePagination-caption,
        .dark-mode .financial-filing-grid .MuiTablePagination-selectIcon,
        .dark-mode .financial-filing-grid .MuiIconButton-root,
        .dark-mode .financial-filing-grid .MuiDataGrid-columnSeparator {
          color: #d8d8d8;
        }

        .dark-mode .financial-filing-grid a {
          color: #d9b3ff;
        }
      `}</style>
      <div className="financial-filing-grid">
        <DataGrid
          rows={rows}
          columns={columns}
          pageSize={6}
          rowsPerPageOptions={[6]}
          autoHeight={true}
          autoPageSize={true}
          density={"compact"}
          disableColumnMenu
        />
      </div>
    </div>
  );
}

export default FinancialFilingDataGrid;
